<template>
  <div>
    <v-container fill-height>
      <v-layout
        justify-center
        align-center
        wrap
      >
        <v-flex
          hidden-sm-and-down
          md6
        >
          <v-img
            src="/static/ideas.jpg"
            height="75vh"
          />
        </v-flex>
        <v-flex
          xs12
          md6
          align-content-space-between
          layout
          :pa-5="$vuetify.breakpoint.smAndDown"
          wrap
        >
          <v-layout
            align-center
            justify-center
          >
            <v-flex
              xs10
              md6
            >
              <h1>Welcome to <span class="important">NBinfo</span></h1>
              <div>
                <p>
                  You have ended up the right place if you want assistance in this area:
                </p>
                <h3><span class="important">IT, software &amp; Internet-applications</span></h3>
                <v-img
                  src="/static/ideas.jpg"
                  width="100%"
                />
              </div>
              <v-layout justify-center>
                <div class="v-card__actions">
                  <button
                    type="button"
                    class="px-5 v-btn theme--light primary"
                    @click="learnMore"
                  >
                    <div class="v-btn__content">
                      Learn More!
                    </div>
                  </button>
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<style scoped>
  span.important {font-weight:bold; color:#ec8000;}
  v-btn.mt-4 {background-color:#ec8000 !important;}
</style>

<script>
  import router from '../router'
  export default {
    metaInfo: {
      title: 'nbinfo.eu',
      meta: [
        { name: 'description', content: 'Customized vue-cli templates for nbinfo.eu' }
      ]
    },

    data: () => ({
      items: ['/static/home-parallax.png']
    }),

    computed: {
      cardFeatures () {
        return this.$t('Home.cardFeatures')
      },
      testimonials () {
        return this.$t('Home.testimonials')
      }
    },
    methods: {
      learnMore: function () {
        router.push({ path: '/services' })
      }
    }
  }
</script>
